import { useEffect, useState } from 'react'
import clsx from 'clsx'
import * as Scroll from 'react-scroll';
import SocialShares from '../common/SocialShares'
import Footer from '../Footer'

export default function Layout({ type="", children }) {
  const [loaded, setLoaded] = useState(false);
  useEffect(()=> {
    Scroll.scroller.scrollTo('top',{
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart'
    });
    setLoaded(true);
  }, [])


  return (
    <>
       <div className={clsx("layout min-h-screen", type)}>
        <div className={clsx("bg", loaded && 'loaded', type)}/>
        <main>{children}</main>
        <SocialShares />
       </div>
      <Footer />
    </>
  )
}
